import "./lesson-assessment-report.css";
import { BsCheckCircle, BsXCircle } from "react-icons/bs";
import {
  capitalize,
  capitalizeAll,
  convertDuration,
  isEmpty,
} from "../../../../core/utils/helpers";

const LessonAssessmentReport = ({ report_data }) => {
  return (
    <div className="lesson-assessment-report">
      {isEmpty(report_data) ? (
        <p>No Data about the lesson assessment Report available yet!</p>
      ) : (
        report_data?.map((row, idx) => {
          return (
            <div className="pcr-question-item" key={row?.details_id}>
              <div className="pcr-q-i-head">
                <span className="q-tick">Question {idx + 1}</span>
              </div>
              <div className="q-tick-titles">
                <span>The question was picked up from :</span>
                <div className="row">
                  <span>Chapter title :</span>
                  <h2>{capitalizeAll(row?.chapter_title)}</h2>
                </div>
                <div className="row">
                  <span>Lesson title :</span>
                  <h2>{capitalizeAll(row?.lesson_title)}</h2>
                </div>
                <div className="row">
                  <span>Measure Indicator :</span>
                  <h2>{capitalizeAll(row?.measure_indicator)}</h2>
                </div>
              </div>
              <div className="pcr-q-i-ruban">
                <div className="ruban-tile">
                  <span>Question Level</span>
                  <p>{capitalize(row?.difficulty)}</p>
                </div>
                <div className="ruban-tile">
                  <span>Question Type</span>
                  <p>
                    {row?.type === "OCA"
                      ? "Single Choice Answer"
                      : "Multiple Choice Answers"}
                  </p>
                </div>
                <div className="ruban-tile">
                  <span>Duration</span>
                  <p>{convertDuration(row?.timing)}</p>
                </div>
                <div className="ruban-tile">
                  <span>Max points</span>
                  <p>{row?.points} points</p>
                </div>
                <hr />
                <div className="ruban-tile">
                  <span>Responded in</span>
                  <p>{convertDuration(row?.responded_timing)}</p>
                </div>
                <div className="ruban-tile">
                  <span>Points won</span>
                  <p>{row?.responded_points} points</p>
                </div>
              </div>
              <div className="pcr-q-i-description">
                <span>Question's Description</span>
                <p
                  dangerouslySetInnerHTML={{
                    __html: row?.description,
                  }}
                />
              </div>
              <div className="pcr-q-i-explanations">
                <span>Question's Explanations</span>
                <p
                  dangerouslySetInnerHTML={{
                    __html: row?.explanations,
                  }}
                />
              </div>
              <div className="pcr-q-i-answers">
                <span className="pcr-q-i-answers-head">Your responses</span>
                <div className="pcr-q-i-answers-content">
                  {row?.responded_answers?.map((ans, idx) => {
                    return (
                      <div
                        className={
                          ans?.is_correct
                            ? "pcr-q-i-a-item is-correct"
                            : "pcr-q-i-a-item is-incorrect"
                        }
                        key={idx}
                      >
                        {ans.is_correct ? (
                          <BsCheckCircle className="icon is-correct" />
                        ) : (
                          <BsXCircle className="icon is-incorrect" />
                        )}

                        <p
                          dangerouslySetInnerHTML={{
                            __html: ans.answer,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="pcr-q-i-answers">
                <span className="pcr-q-i-answers-head">Expected responses</span>
                <div className="pcr-q-i-answers-content">
                  {row?.answers?.map((ans, idx) => {
                    return (
                      <div
                        className={
                          ans?.is_correct
                            ? "pcr-q-i-a-item is-correct"
                            : "pcr-q-i-a-item is-incorrect"
                        }
                        key={idx}
                      >
                        {ans.is_correct ? (
                          <BsCheckCircle className="icon is-correct" />
                        ) : (
                          <BsXCircle className="icon is-incorrect" />
                        )}

                        <p
                          dangerouslySetInnerHTML={{
                            __html: ans.answer,
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default LessonAssessmentReport;
